export default __webpack_public_path__ + "assets/images/roadmap-moon.dede4904.png";